import { Paperclip } from 'lucide-react';

/**
 * The bordered paperclip chip shown on a ledger/transaction row to surface its
 * attachments. Shared so journal entries and bank transactions look identical.
 */
export function AttachmentChip({
  label,
  title,
  onClick,
}: {
  label: string;
  title?: string;
  onClick: (e: React.MouseEvent) => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      title={title}
      className="hidden max-w-[10rem] shrink-0 items-center gap-1 rounded-md border border-border/60 bg-card px-2 py-1 text-xs text-muted-foreground transition-colors hover:border-border hover:text-foreground sm:inline-flex"
    >
      <Paperclip className="size-3 shrink-0" />
      <span className="truncate">{label}</span>
    </button>
  );
}
